const registration_routes = {
      path: "/registration",
      name: "Registration",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        // 报名表
        {
          path: "register_vita",
          component: () => import('@/views/Registration/vita/vita'),
          meta: {requiresAuth: true},
        },
        // 报名详情
        {
          path: "register_info",
          component: () => import('@/components/Registration/RegistrationInfo'),
          meta: {requiresAuth: true},
        },
        // 上传附件
        {
          path: "register_file",
          component: () => import('@/views/Registration/vita/vitaFile'),
          meta: {requiresAuth: true},
        },
        {
          path: "register_all_vita",

          component: () => import('@/views/training_student/vita/vita'),
          meta: {requiresAuth: true},
        },
      ]
    }

export default registration_routes;